// API Configuration
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// NBA Team Logo URLs
export const NBA_TEAM_LOGOS = {
  "ATL": "https://cdn.nba.com/logos/nba/1610612737/global/L/logo.svg",
  "BOS": "https://cdn.nba.com/logos/nba/1610612738/global/L/logo.svg",
  "BKN": "https://cdn.nba.com/logos/nba/1610612751/global/L/logo.svg",
  "CHA": "https://cdn.nba.com/logos/nba/1610612766/global/L/logo.svg",
  "CHI": "https://cdn.nba.com/logos/nba/1610612741/global/L/logo.svg",
  "CLE": "https://cdn.nba.com/logos/nba/1610612739/global/L/logo.svg",
  "DAL": "https://cdn.nba.com/logos/nba/1610612742/global/L/logo.svg",
  "DEN": "https://cdn.nba.com/logos/nba/1610612743/global/L/logo.svg",
  "DET": "https://cdn.nba.com/logos/nba/1610612765/global/L/logo.svg",
  "GSW": "https://cdn.nba.com/logos/nba/1610612744/global/L/logo.svg",
  "HOU": "https://cdn.nba.com/logos/nba/1610612745/global/L/logo.svg",
  "IND": "https://cdn.nba.com/logos/nba/1610612754/global/L/logo.svg",
  "LAC": "https://cdn.nba.com/logos/nba/1610612746/global/L/logo.svg",
  "LAL": "https://cdn.nba.com/logos/nba/1610612747/global/L/logo.svg",
  "MEM": "https://cdn.nba.com/logos/nba/1610612763/global/L/logo.svg",
  "MIA": "https://cdn.nba.com/logos/nba/1610612748/global/L/logo.svg",
  "MIL": "https://cdn.nba.com/logos/nba/1610612749/global/L/logo.svg",
  "MIN": "https://cdn.nba.com/logos/nba/1610612750/global/L/logo.svg",
  "NOP": "https://cdn.nba.com/logos/nba/1610612740/global/L/logo.svg",
  "NYK": "https://cdn.nba.com/logos/nba/1610612752/global/L/logo.svg",
  "OKC": "https://cdn.nba.com/logos/nba/1610612760/global/L/logo.svg",
  "ORL": "https://cdn.nba.com/logos/nba/1610612753/global/L/logo.svg",
  "PHI": "https://cdn.nba.com/logos/nba/1610612755/global/L/logo.svg",
  "PHX": "https://cdn.nba.com/logos/nba/1610612756/global/L/logo.svg",
  "POR": "https://cdn.nba.com/logos/nba/1610612757/global/L/logo.svg",
  "SAC": "https://cdn.nba.com/logos/nba/1610612758/global/L/logo.svg",
  "SAS": "https://cdn.nba.com/logos/nba/1610612759/global/L/logo.svg",
  "TOR": "https://cdn.nba.com/logos/nba/1610612761/global/L/logo.svg",
  "UTA": "https://cdn.nba.com/logos/nba/1610612762/global/L/logo.svg",
  "WAS": "https://cdn.nba.com/logos/nba/1610612764/global/L/logo.svg",
};

// MLB Team Logo URLs (ESPN CDN)
export const MLB_TEAM_LOGOS = {
  "ARI": "https://a.espncdn.com/i/teamlogos/mlb/500/ari.png",
  "ATL": "https://a.espncdn.com/i/teamlogos/mlb/500/atl.png",
  "BAL": "https://a.espncdn.com/i/teamlogos/mlb/500/bal.png",
  "BOS": "https://a.espncdn.com/i/teamlogos/mlb/500/bos.png",
  "CHC": "https://a.espncdn.com/i/teamlogos/mlb/500/chc.png",
  "CHW": "https://a.espncdn.com/i/teamlogos/mlb/500/chw.png",
  "CWS": "https://a.espncdn.com/i/teamlogos/mlb/500/chw.png",  // alias
  "CIN": "https://a.espncdn.com/i/teamlogos/mlb/500/cin.png",
  "CLE": "https://a.espncdn.com/i/teamlogos/mlb/500/cle.png",
  "COL": "https://a.espncdn.com/i/teamlogos/mlb/500/col.png",
  "DET": "https://a.espncdn.com/i/teamlogos/mlb/500/det.png",
  "HOU": "https://a.espncdn.com/i/teamlogos/mlb/500/hou.png",
  "KC": "https://a.espncdn.com/i/teamlogos/mlb/500/kc.png",
  "LAA": "https://a.espncdn.com/i/teamlogos/mlb/500/laa.png",
  "LAD": "https://a.espncdn.com/i/teamlogos/mlb/500/lad.png",
  "MIA": "https://a.espncdn.com/i/teamlogos/mlb/500/mia.png",
  "MIL": "https://a.espncdn.com/i/teamlogos/mlb/500/mil.png",
  "MIN": "https://a.espncdn.com/i/teamlogos/mlb/500/min.png",
  "NYM": "https://a.espncdn.com/i/teamlogos/mlb/500/nym.png",
  "NYY": "https://a.espncdn.com/i/teamlogos/mlb/500/nyy.png",
  "OAK": "https://a.espncdn.com/i/teamlogos/mlb/500/oak.png",
  "PHI": "https://a.espncdn.com/i/teamlogos/mlb/500/phi.png",
  "PIT": "https://a.espncdn.com/i/teamlogos/mlb/500/pit.png",
  "SD": "https://a.espncdn.com/i/teamlogos/mlb/500/sd.png",
  "SF": "https://a.espncdn.com/i/teamlogos/mlb/500/sf.png",
  "SEA": "https://a.espncdn.com/i/teamlogos/mlb/500/sea.png",
  "STL": "https://a.espncdn.com/i/teamlogos/mlb/500/stl.png",
  "TB": "https://a.espncdn.com/i/teamlogos/mlb/500/tb.png",
  "TEX": "https://a.espncdn.com/i/teamlogos/mlb/500/tex.png",
  "TOR": "https://a.espncdn.com/i/teamlogos/mlb/500/tor.png",
  "WSH": "https://a.espncdn.com/i/teamlogos/mlb/500/wsh.png",
};

// NFL / NHL / Soccer placeholders — populated when those sports launch.
// Sport-keyed dispatch below already routes the lookup safely.
export const NFL_TEAM_LOGOS = {};
export const NHL_TEAM_LOGOS = {};
export const SOCCER_TEAM_LOGOS = {};

// Sport → logo-map registry. Adding a new sport = add a new entry here.
const _LOGO_MAPS = {
  nba: NBA_TEAM_LOGOS,
  mlb: MLB_TEAM_LOGOS,
  nfl: NFL_TEAM_LOGOS,
  nhl: NHL_TEAM_LOGOS,
  soccer: SOCCER_TEAM_LOGOS,
};

/**
 * Sport-aware team logo resolver — the ONLY supported lookup path.
 *
 * Resolution order (per Universal Logo Contract 2026-04-29):
 *   1. `team_logo_url` argument: backend-provided, used as-is (already
 *      sport-matched at the source).
 *   2. `_LOGO_MAPS[sport][team]`: sport-keyed local map.
 *   3. `null` → caller renders initials fallback.
 *
 * NEVER falls through to a different sport. Critical because team
 * abbreviations collide across leagues (BOS, ATL, CLE, DET, HOU, MIA,
 * MIL, MIN, PHI, TOR are all duplicated NBA↔MLB; CAR, NY, LA, SF, ARI
 * collide across NFL/NHL/MLB).
 *
 * @param {string} sport  - 'nba' | 'mlb' | 'nfl' | 'nhl' | 'soccer'
 * @param {string} team   - team abbreviation
 * @param {string} [team_logo_url] - optional backend override
 * @returns {string|null}
 */
export const getTeamLogo = (sport, team, team_logo_url = null) => {
  if (team_logo_url) return team_logo_url;
  if (!sport || !team) return null;
  const map = _LOGO_MAPS[String(sport).toLowerCase()];
  if (!map) return null;
  return map[team] || null;
};

// Cache Keys
export const CACHE_KEYS = {
  PLAYERS: 'dg_players',
  LINES: 'dg_lines',
  RADAR: 'dg_radar',
  VAULT: 'dg_vault',
  PARLAYS: 'dg_parlays',
};

// Market Short Names
export const MARKET_SHORT = {
  'player_points': 'Points',
  'player_rebounds': 'Rebounds',
  'player_assists': 'Assists',
  'player_threes': '3PM',
  'player_steals': 'Steals',
  'player_blocks': 'Blocks',
  'player_turnovers': 'Turnovers',
  'player_points_rebounds_assists': 'Pts+Reb+Ast',
  'player_points_rebounds': 'Pts+Reb',
  'player_points_assists': 'Pts+Ast',
  'player_rebounds_assists': 'Reb+Ast',
  'player_steals_blocks': 'Stl+Blk',
  'player_double_double': 'Double-Double',
  'player_triple_double': 'Triple-Double',
};

export const getMarketName = (market) => {
  return MARKET_SHORT[market] || market.replace('player_', '').replace(/_/g, ' ');
};

// Stat Categories for Player Detail Page
export const STAT_CATEGORIES = {
  'combo': { name: 'Combo Stats', color: 'text-purple-400', markets: ['player_points_rebounds_assists', 'player_points_rebounds', 'player_points_assists', 'player_rebounds_assists', 'player_steals_blocks'] },
  'points': { name: 'Points', color: 'text-yellow-400', markets: ['player_points'] },
  'rebounds': { name: 'Rebounds', color: 'text-blue-400', markets: ['player_rebounds'] },
  'assists': { name: 'Assists', color: 'text-green-400', markets: ['player_assists'] },
  'threes': { name: '3-Pointers', color: 'text-orange-400', markets: ['player_threes'] },
  'defense': { name: 'Defense', color: 'text-red-400', markets: ['player_steals', 'player_blocks'] },
  'other': { name: 'Other', color: 'text-zinc-400', markets: ['player_turnovers', 'player_double_double', 'player_triple_double'] },
};

export const getCategoryKey = (market) => {
  for (const [key, cat] of Object.entries(STAT_CATEGORIES)) {
    if (cat.markets.includes(market)) return key;
  }
  return 'other';
};

export const getCategoryColor = (key) => {
  const colors = {
    'combo': 'border-purple-500 bg-purple-950/30',
    'points': 'border-yellow-500 bg-yellow-950/30',
    'rebounds': 'border-blue-500 bg-blue-950/30',
    'assists': 'border-green-500 bg-green-950/30',
    'threes': 'border-orange-500 bg-orange-950/30',
    'defense': 'border-red-500 bg-red-950/30',
    'other': 'border-zinc-500 bg-zinc-900/30',
  };
  return colors[key] || colors.other;
};
